import { render, staticRenderFns } from "./scanRecord.vue?vue&type=template&id=b741ed5c&scoped=true"
import script from "./scanRecord.vue?vue&type=script&lang=js"
export * from "./scanRecord.vue?vue&type=script&lang=js"
import style0 from "./scanRecord.vue?vue&type=style&index=0&id=b741ed5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b741ed5c",
  null
  
)

export default component.exports